var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1053 7.38063H13.5195C11.3989 7.38063 9.67211 5.65379 9.67211 3.53326V0.947471C9.67211 0.455366 9.26947 0.0527344 8.77737 0.0527344H4.98368C2.22789 0.0527344 0 1.84221 0 5.03642V12.9638C0 16.158 2.22789 17.9475 4.98368 17.9475H12.0163C14.7721 17.9475 17 16.158 17 12.9638V8.27537C17 7.78326 16.5974 7.38063 16.1053 7.38063ZM8.75053 12.3822L6.96105 14.1717C6.89842 14.2343 6.81789 14.288 6.73737 14.3148C6.65684 14.3506 6.57632 14.3685 6.48684 14.3685C6.39737 14.3685 6.31684 14.3506 6.23632 14.3148C6.16474 14.288 6.09316 14.2343 6.03947 14.1806C6.03053 14.1717 6.02158 14.1717 6.02158 14.1627L4.23211 12.3733C3.97263 12.1138 3.97263 11.6843 4.23211 11.4248C4.49158 11.1654 4.92105 11.1654 5.18053 11.4248L5.81579 12.078V8.32905C5.81579 7.96221 6.12 7.658 6.48684 7.658C6.85368 7.658 7.15789 7.96221 7.15789 8.32905V12.078L7.80211 11.4338C8.06158 11.1743 8.49105 11.1743 8.75053 11.4338C9.01 11.6933 9.01 12.1227 8.75053 12.3822Z",
    fill: "#251163"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3575 6.14602C14.2075 6.15496 15.3886 6.15496 16.3996 6.15496C16.9096 6.15496 17.178 5.55549 16.8201 5.19759C15.5317 3.90023 13.2233 1.56496 11.8991 0.240751C11.5322 -0.126091 10.897 0.124436 10.897 0.634436V3.75707C10.897 5.06338 12.0064 6.14602 13.3575 6.14602Z",
    fill: "#251163"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentDownload);
export default __webpack_public_path__ + "static/media/document-download.1a29783372a2b6969db07b57183375f2.svg";
export { ForwardRef as ReactComponent };